import {
  createLightTheme,
  type BrandVariants,
  type Theme,
} from '@fluentui/react-components';
import { brandColors } from './brandColors';

/* Custom Fluent UI v9 brand ramp centred on Transformr Blue (`#0066b2`).
   `createLightTheme(brandVariants)` produces a complete `Theme` object where
   every `tokens.colorBrand*` reference (primary buttons, links, focus rings,
   active-nav background, badges with `color="brand"`, etc.) resolves to a
   shade of Transformr blue instead of the default Microsoft Office blue.

   The 16-stop ramp follows Fluent's convention: stop 80 is the brand colour
   itself, 10 is darkest, 160 is lightest. Stops were generated by
   interpolating in HSL from `#0066b2` (H=204°, S=100%, L=35%). */

export const transformrBrand: BrandVariants = {
  10:  '#020305',
  20:  '#0E1A26',
  30:  '#122C46',
  40:  '#133D62',
  50:  '#144F7C',
  60:  '#126097',
  70:  '#0A6FAE',
  80:  brandColors.blue, // #0066B2 — the brand colour
  90:  '#2A82BE',
  100: '#4A97CA',
  110: '#66A9D5',
  120: '#82BBE0',
  130: '#9DCDEB',
  140: '#B8DEF3',
  150: '#D2EAF9',
  160: '#E9F4FC',
};

export const transformrLightTheme: Theme = createLightTheme(transformrBrand);
